import { useState } from "react";

import ReferralURL from "components/account/ReferralURL";
import Callout from "hardcover-ui/components/Callout";
import Heading from "hardcover-ui/components/Heading";
import Icon from "hardcover-ui/components/Icon";
import TextLink from "hardcover-ui/components/TextLink";
import useCurrentUser from "hooks/fragments/useCurrentUser";
import useMount from "hooks/useMount";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import closeIcon from "icons/regular/x.svg";
import {
  PageSerializersBooksLayout,
  UserBookSerializersUserBookReview,
} from "types/serializers";

export default function BookOwnerReviewNotice({
  book,
  userBook,
}: {
  book: PageSerializersBooksLayout;
  userBook: UserBookSerializersUserBookReview;
}) {
  const currentUserId = useCurrentUserId();
  const username = useCurrentUser(user => user.username);
  const mounted = useMount();
  const [showNotice, setShowNotice] = useState(true);

  if (
    !mounted ||
    currentUserId !== userBook.userId ||
    !username ||
    !showNotice
  ) {
    return <></>;
  }

  const referralLink = `${window.location.origin}/books/${book.slug}/reviews/@${username}?referrer_id=${currentUserId}`;

  return (
    <Callout className="relative">
      <Heading level={2} variant="title" size="sm">
        This is Your Review
      </Heading>
      <button
        type="button"
        className="absolute top-2 right-2 hover:bg-yellow-500 rounded-lg p-1"
        onClick={() => setShowNotice(false)}
      >
        <span className="sr-only">Close</span>
        <Icon icon={closeIcon} size="lg" />
      </button>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="space-y-4">
          <p>
            Only you will see this part at the top. Below is your review. You
            can{" "}
            <TextLink href={`/books/${book.slug}/reviews/edit`} variant="none">
              edit your review
            </TextLink>{" "}
            at anytime.
          </p>

          <p>
            Here's the preview of what others will see when you share your
            review on social channels (we've added your{" "}
            <TextLink href="/account/referrals" variant="none">
              referral code
            </TextLink>{" "}
            to this link too).
          </p>

          <ReferralURL referralUrl={referralLink} />
        </div>

        <div>
          <img
            alt="Review preview"
            src={`/books/${book.slug}/reviews/@${username}/ogimage.png`}
          />
        </div>
      </div>
    </Callout>
  );
}
